module.exports = __webpack_public_path__ + "static/media/mainimg-11.c922de04.png";